// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-title > div[data-v-58986684] {\n  border: 3px solid white;\n  padding: 3px 4px;\n  border-radius: 30px;\n  -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);\n}", ""]);
// Exports
module.exports = exports;
